import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { UserDeleteOutlined } from '@ant-design/icons';
import { Button, Modal , message } from 'antd';

import StrikeTeamDetailsModel from '../../models/StrikeTeamDetailsModel';
import TrackerService from '../../utils/TrackerService';

const { confirm } = Modal;

export const TeamMemberLeaveButton = ({ clientId, team, isAdmin, ...rest }) => {
    const { teamId, teamName, teamOwnerClientId, teamNumberOfMembers = 0 } = team;
    const memberClientId = clientId;
    const memberDisplayName = "Self";
    const [isMemberDeleted, setIsMemberDeleted] = useState(false);
    const history = useHistory();

    const isOwnerAsLastMember = clientId === teamOwnerClientId && teamNumberOfMembers === 1;

    const updatedBlockedStateTo = (isBlocked) => {
        setIsMemberDeleted(isBlocked);
    };

    const deleteMember = async () => {
        const model = new StrikeTeamDetailsModel({
            teamId,
            memberClientId,
        });

        const modalContent = isOwnerAsLastMember ? (
            <>
                <br />
                <p><strong>You are deleting your access to this team.</strong></p>
                <p>You will not be able to restore it. No one will be able to access the team. Your tip history will be maintained for records.</p>
                <p>Please confirm you want to delete your access to <strong>{teamName}</strong>.</p>
            </>
        ) : (
            <>
                <br />
                <p><strong>Warning:</strong> You will not be able to earn new tips from this team.</p>
                <p>Of course, you keep all of your existing tips.</p>
                <p>Please confirm you want to leave the team, <strong>{teamName}</strong>.</p>
            </>
        );

        confirm({
            icon: <UserDeleteOutlined />,
            title: isOwnerAsLastMember ? 'Delete your access to this team?' : 'Do you want to leave this team?',
            content: modalContent,
            okText: isOwnerAsLastMember ? 'Delete' : 'Leave',
            okButtonProps: isOwnerAsLastMember ? { danger: true } : undefined,
            centered: true,

            async onOk() {
                try {
                    await model.leaveTeamViaCloudFunction(teamId, memberClientId);
                    updatedBlockedStateTo(true);
                    const basePath = isAdmin ? '/admin/clients' : '/client/manage';
                    const url = `${basePath}/${clientId}`;
                    history.push(`${url}`);
                } catch (err) {
                    const msg = err?.message || 'Failed to leave team.';
                    message.error(msg);
                    throw err;
                }
            },
        });
    };

    const isLocalHost = window.location.hostname === 'localhost';
    const isTest = isLocalHost;

    const tracker = new TrackerService({
      isTest,
    });

    const data = {
      memberClientId,
      memberDisplayName,
      teamId,
      teamName,
    }

    const onClickDelete = async () => {
      deleteMember();

      tracker.mixpanelTrack('team_member_leave', data);

      if (!isTest) {
        tracker.googleTrack('team_member_leave', data);
      }
    };

    return (
        <>
            {!isMemberDeleted &&
                <Button 
                  key={`member-leave-button-${memberClientId}`} 
                  type='default' 
                  onClick={onClickDelete} 
                  {...rest} 
                  danger 
                  icon={<UserDeleteOutlined />}
                >
                  {isOwnerAsLastMember ? 'Delete' : 'Leave'}
                </Button>}
        </>
    );
};
